<template>
  <div class="users">
    <v-toolbar text color="white" class="mb-4">
      <v-toolbar-title>{{ $t("heading.users") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="dialog = !dialog">Create</v-btn>
    </v-toolbar>
    <!-- form-wrapper -->
    <form-wrapper :validator="$v.editedItem">
      <v-dialog v-model="dialog" max-width="600" text>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-form @submit.prevent="save">
            <v-tabs fixed-tabs slider-color="blue">
              <v-tab ripple>{{ $t("users.tabs_titles.main") }}</v-tab>
              <v-tab-item>
                <v-card text min-height="400">
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex
                          xs12
                          sm6
                          md12
                          align-center
                          justify-center
                          layout
                          text-xs-center
                          class="mb-5"
                          v-if="editedIndex > -1 || editedIndex !== -1"
                        >
                          <v-avatar
                            size="120"
                            color="grey lighten-4"
                            class="img_avatar"
                            v-if="editedItem.photo && editedIndex > -1"
                          >
                            <img :src="editedItem.photo.path" alt="avatar" />
                          </v-avatar>

                          <v-avatar
                            size="120"
                            color="grey lighten-4"
                            class="img_avatar"
                            v-if="editedItem.photo === null && editedIndex > -1"
                          >
                            <img src="@/assets/imgs/user.png" alt="avatar" />
                          </v-avatar>
                          <v-icon
                            v-if="editedItem.photo !== null && editedIndex > -1"
                            class="pb-5 img_delete"
                            title="Dlete User Image"
                            @click="deleteUserImg(editedItem)"
                            >delete</v-icon
                          >
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <form-group name="firstname">
                            <template slot-scope="{ attrs }">
                              <v-text-field
                                v-bind="attrs"
                                v-model="editedItem.firstname"
                                @input="$v.editedItem.firstname.$touch()"
                                @keyup="change = false"
                              ></v-text-field>
                            </template>
                          </form-group>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <form-group name="lastname">
                            <template slot-scope="{ attrs }">
                              <v-text-field
                                v-bind="attrs"
                                v-model="editedItem.lastname"
                                @input="$v.editedItem.lastname.$touch()"
                                @keyup="change = false"
                              ></v-text-field>
                            </template>
                          </form-group>
                        </v-flex>
                        <v-flex xs12 md6>
                          <form-group name="email">
                            <template slot-scope="{ attrs }">
                              <v-text-field
                                v-bind="attrs"
                                type="email"
                                v-model="editedItem.email"
                                @input="$v.editedItem.email.$touch()"
                                @keyup="change = false"
                              ></v-text-field>
                            </template>
                          </form-group>
                        </v-flex>

                        <v-flex xs12 md12 v-show="!isUpdate">
                          <form-group name="password">
                            <template slot-scope="{ attrs }">
                              <v-text-field
                                v-bind="attrs"
                                type="password"
                                v-model="editedItem.password"
                                @input="$v.editedItem.password.$touch()"
                                @keyup="change = false"
                                autocomplete
                              ></v-text-field>
                            </template>
                          </form-group>
                        </v-flex>

                        <v-flex xs12 md6>
                          <form-group name="phone">
                            <template slot-scope="{ attrs }">
                              <v-text-field
                                v-bind="attrs"
                                type="tel"
                                v-model="editedItem.phone"
                                @input="$v.editedItem.phone.$touch()"
                                @keyup="change = false"
                              ></v-text-field>
                            </template>
                          </form-group>
                        </v-flex>

                        <v-flex xs12 md6>
                          <v-menu
                            v-model="dateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            full-width
                            min-width="290px"
                            @change="change = false"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"
                                v-model="editedItem.clearBirthDate"
                                :label="$t('fields_names.birthdate')"
                                prepend-icon=""
                                readonly
                                @change="change = false"
                                :error-messages="
                                  $store.getters.getServerErrors
                                    ? $store.getters.getServerErrors[
                                        'birthdate'
                                      ]
                                    : ''
                                "
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="editedItem.clearBirthDate"
                              @input="dateMenu = false"
                              @change="change = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-select
                            v-model="editedItem.gender"
                            :items="genderOptions"
                            :label="$t('fields_names.gender')"
                            @change="change = false"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab ripple>{{ $t("users.tabs_titles.roles") }}</v-tab>
              <v-tab-item>
                <v-card text min-height="400">
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 md12>
                          <v-select
                            :label="$t('fields_names.roles')"
                            :items="rolesOptions"
                            v-model="editedItem.roles_ids"
                            multiple
                            chips
                            persistent-hint
                            @change="
                              editedItem.roles_ids.length > 0
                                ? (change = false)
                                : (change = true)
                            "
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <template v-if="editedIndex > -1">
                <v-tab ripple>{{ $t("users.tabs_titles.addresses") }}</v-tab>
                <v-tab-item>
                  <v-card text min-height="400">
                    <v-card-text>
                      <v-expansion-panel>
                        <v-expansion-panel-content
                          v-for="(address, index) in editedItem.addresses"
                          :key="index"
                        >
                          <div slot="header">{{ address.address_name }}</div>
                          <v-card>
                            <v-card-text>
                              <ul row wrap>
                                <li>
                                  <span class="font-weight-bold"
                                    >Person Name :</span
                                  >
                                  {{ address.person_name }}
                                </li>
                                <li>
                                  <span class="font-weight-bold">City :</span>
                                  {{ address.city }}
                                </li>
                                <li>
                                  <span class="font-weight-bold"
                                    >Phone Number :</span
                                  >
                                  {{ address.phone }}
                                </li>
                                <li>
                                  <span class="font-weight-bold"
                                    >Detailed Address :</span
                                  >
                                  {{ address.detailed_address }}
                                </li>

                                <li>
                                  <span class="font-weight-bold"
                                    >Postal Code :</span
                                  >
                                  {{ address.postal_code }}
                                </li>
                              </ul>
                            </v-card-text>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </template>
            </v-tabs>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false"
                >Close</v-btn
              >
              <v-btn
                type="submit"
                color="blue darken-1"
                text
                :loading="loadingState"
                :disabled="$v.editedItem.$invalid || change"
                >Save</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </form-wrapper>

    <v-data-table
      :items="items"
      :headers="headers"
      hide-default-footer
      :mobile-breakpoint="zero"
      disable-pagination
      :loading="loadingState"
    >
      <template v-slot:item="{ item, index }">
        <tr>
          <td class="text-center">{{ item.username }}</td>
          <td class="text-center">{{ item.email }}</td>
          <td class="text-center">{{ item.phone }}</td>

          <td class="py-1">
            <img
              width="50px"
              :src="getImagePath(item)"
              alt="main_photo"
              title="main photo"
            />
          </td>
          <td class="toggle-spacing text-center">
            <toggle-service
              :is-edit="true"
              model-name="user"
              :model-id="item.id"
              field="blocked"
              v-model="item.blocked"
              :validate="true"
            />
          </td>

          <!-- <td>
            <v-btn small color="primary" @click="setAsProvider(item)"
              >Set as Provider</v-btn
            >
          </td> -->

          <td class="text-center">
            <v-icon small class="mr-2 edit" @click="editItem(item, index)">
              mdi-pencil
            </v-icon>
            <v-icon class="delete" small @click="deleteItem(item, index)">
              mdi-delete
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>

    <div class="text-xs-center pt-2">
      <v-pagination
        v-if="items.length > 0 && pagination.last_page > 1"
        v-model="pagination.current_page"
        :length="pagination.last_page"
        :total-visible="10"
        @input="loadUsers"
      ></v-pagination>
    </div>
  </div>
</template>
<script>
import {
  required,
  maxLength,
  minLength,
  email,
  numeric
} from "vuelidate/lib/validators";
import {
  createUser,
  updateUser,
  deleteUser,
  showUser,
  blockUser,
  indexUsersByPage,
  deleteUserImg
} from "@/api/users";
import { indexRoles } from "@/api/roles";

import moment from "moment";
export default {
  name: "users",
  components: {},
  data() {
    return {
      usersHeader: [
        "firstname",
        "lastname",
        "email",
        "phone",
        "photo",
        "blocked"
      ],
      toggle: ["blocked"],
      ignores: ["photo"],
      imgsName: ["photo"],

      headers: [
        {
          text: "Name",
          sortable: false,
          align: "center"
        },

        {
          text: "email",
          sortable: false,
          align: "center"
        },
        {
          text: "phone",
          sortable: false,
          align: "center"
        },
        {
          text: "photo",
          sortable: false,
          align: "center"
        },
        {
          text: "blocked",
          sortable: false,
          align: "center"
        },
        // {
        //   text: "",
        //   sortable: false,
        //   align: "center"
        // },
        {
          text: "configurations",
          sortable: false,
          align: "center"
        }
      ],

      dialog: false,
      dateMenu: false,
      items: [],
      rolesOptions: [],
      genderOptions: [{ text: "male", value: 1 }, { text: "female", value: 2 }],
      pagination: {
        current_page: 0,
        last_page: 0
      },
      isUpdate: false,
      change: true,
      editedIndex: -1,
      editedItem: {},
      defaultItem: {
        firstname: "",
        email: "",
        password: "",
        gender: 0
      },
      loadingState: false,
      imgCheack: false,
      ROLES_TAB: 1,
      ADDRESS_TAB: 2,
      zero: 0
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
      createUser;
      this.change = true;
      this.loadingState = false;
      this.$v.$reset();
      this.$store.dispatch("ServerErrors"); // clear serverErorrs
    },
    $route: {
      handler: function(route) {
        this.pagination.current_page = route.query.page;
      },
      immediate: true
    }
  },
  filters: {
    filterName(val) {
      // start with 0 and end with string length - what length i want to be
      return val.substring(0, val.length - 5) + "...";
    }
  },
  mounted() {
    indexRoles()
      .then(res => {
        this.rolesOptions = res.data.data.map(elm => {
          return {
            value: elm.id,
            text: elm.display_name
          };
        });
      })
      .catch(() => {});
  },
  created() {
    if (this.$route.query) {
      const page = this.$route.query.page || 1;
      this.loadUsers(page);
    } else {
      this.loadUsers(this.pagination.current_page);
    }
  },
  methods: {
    loadUsers(pageNumber) {
      indexUsersByPage(pageNumber)
        .then(res => {
          this.$router.push({
            query: {
              page: this.pagination.current_page
                ? this.pagination.current_page
                : 1
            }
          });
          console.log(res.data.data);
          this.items = res.data.data;
          this.pagination = res.data.meta;
          this.scrollToTop();
        })
        .catch(() => {});
    },
    editItem(item, index) {
      this.dialog = true;
      this.isUpdate = true;
      this.imgCheack = true;
      this.editedIndex = index;
      this.editedItem = { ...item };
      this.loadCurrentUser();
      this.editedItem.clearBirthDate = item.birthdate
        ? moment(item.birthdate.date).format("YYYY-MM-DD")
        : "";
    },
    deleteItem(item) {
      // console.log(item, index);
      this.popUp("Are You Sure?", "warning").then(value => {
        if (!value.dismiss) {
          deleteUser(item)
            .then(() => {
              let itemIndex = this.items.filter(el => el.id !== item.id);
              this.items = [...itemIndex];
            })
            .catch(() => {});
        }
      });
    },
    toggleItem(item) {
      const reqData = {
        locale: this.lang
      };
      this.popUp("Are You Sure?", "warning").then(value => {
        if (!value.dismiss) {
          blockUser(item, reqData)
            .then(res => {
              console.log(res.data.blocked);
              item.blocked = res.data.blocked;
            })
            .catch(() => {});
        } else {
          item.blocked = !item.blocked;
        }
      });
    },
    // setAsProvider(item) {
    //   this.$router.push({ name: "CreateProvider", query: { id: item.id } });
    // },
    close() {
      this.dialog = false;
      this.change = true;
      this.imgCheack = false;
      this.loadingState = false;

      setTimeout(() => {
        this.$v.$reset();
        this.isUpdate = false;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 100);
    },
    save() {
      this.$v.$touch();
      this.loadingState = true;
      if (this.$v.$invalid) {
        return;
      }
      let reqData = {
        ...this.editedItem,
        locale: "en",
        birthdate: moment(this.editedItem.clearBirthDate).format("YYYY-MM-DD")
      };

      if (this.editedIndex > -1) {
        // update
        const { username } = this.editedItem;
        updateUser(reqData, username)
          .then(res => {
            const { user } = res.data;
            this.items[this.editedIndex] = user;
            this.items = [...this.items]; // important for reactevity updating
            this.loadingState = false;
            this.change = true;
            this.dialog = false;
          })
          .catch(() => {
            this.loadingState = false;
            this.change = true;
          });
      } else {
        // create
        createUser(reqData)
          .then(res => {
            const { user } = res.data;

            this.items.push(user);
            this.loadingState = false;
            this.change = true;
            this.dialog = !this.dialog;
          })
          .catch(() => {
            this.loadingState = false;
            this.change = true;
          });
      }
      // this.close();
    },
    loadCurrentUser() {
      showUser(this.editedItem)
        .then(res => {
          this.editedItem = this.reArrangeCurrentItem(this.editedItem, res);
        })
        .catch(err => {
          console.log("Error", err.response);
        });
    },
    reArrangeCurrentItem(item, res) {
      let temp = {
        ...res.data.user,
        clearBirthDate: item.clearBirthDate
      };
      temp.roles_ids = temp.roles.map(elm => elm.id);
      return temp;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    getImagePath(item) {
      if (item.photo && item.photo.path) {
        return item.photo.path;
      } else {
        return require("@/assets/imgs/user.png");
      }
    },
    deleteUserImg(editedItem) {
      this.popUp("Are You Sure?", "warning").then(value => {
        if (!value.dismiss) {
          deleteUserImg(editedItem.username)
            .then(() => {
              editedItem.photo = null; // to update user img
            })
            .catch(err => console.log(err));
        }
      });
    },
    validationsRules() {
      return {
        editedItem: {
          firstname: {
            required,
            maxLength: maxLength(15),
            minLength: minLength(3)
          },
          lastname: {
            required,
            maxLength: maxLength(15),
            minLength: minLength(3)
          },
          email: { required, email },
          password: {
            required: !this.isUpdate ? required : false,
            minLength: minLength(6)
          },
          phone: {
            required,
            numeric,
            maxLength: maxLength(14),
            minLength: minLength(9)
          },
          clearBirthDate: { required }
        }
      };
    }
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New User" : "Edit User";
    }
  },
  validations() {
    if (!this.isUpdate) {
      return this.validationsRules();
    } else {
      return this.validationsRules();
    }
  }
};
</script>

<style scoped>
.img_delete {
  color: rgb(219, 60, 60);
  transition: all 0.5s ease;
}
.group {
  position: relative;
  /* width: 55%; */
  margin: 0 auto;
}
.select_down {
  position: absolute;
  top: 0;
  right: 0;
  width: 10.5rem;
}
.search_bar {
  position: relative;
}
.v-select__slot {
  background-color: red;
}
</style>
